// antd v5 + Tailwind preflight 충돌로 배경색이 사라져 클래스로 강제 지정한다.
// 반관리 화면의 주요 액션 버튼(추가하기·저장·완료)에 공통으로 쓴다.
export const ANTD_BUTTON_PURPLE_CLASS =
  '!border-purple5 !bg-purple5 !text-white hover:!border-purple6 hover:!bg-purple6 disabled:!border-purple2 disabled:!bg-purple2 disabled:!text-gray3';
